import EventTracker from './EventTracker';

const provider = process.env.NODE_ENV === 'production' ? window.gtag : () => {};

const eventTracker = new EventTracker(provider);

export default eventTracker;



// WEBPACK FOOTER //
// ./src/services/EventTrackerInstance.js